import { useAnalyticsTrackEvent } from '@/utils/analyticsReporter';
import { 
  logVideoCallStart, 
  logVideoCallStateJoined, 
  logVideoCallParticipantStateChange, 
  logVideoCallError, 
  collectWebDeviceInformation 
} from '@/utils/video-call-logger';
import { VideoCallDiagnosticsData, VideoCallLogger } from '../../../../packages/types/types';

export const useVideoCallLogger = (): VideoCallLogger => {
  const trackEvent = useAnalyticsTrackEvent();
  
  return {
    logCallStart: (data: Partial<VideoCallDiagnosticsData>) => logVideoCallStart(trackEvent, data),
    logCallStateJoined: (data: Partial<VideoCallDiagnosticsData>) => logVideoCallStateJoined(trackEvent, data),
    logParticipantStateChange: (data: Partial<VideoCallDiagnosticsData>) => logVideoCallParticipantStateChange(trackEvent, data),
    logError: (eventType: VideoCallDiagnosticsData['event_type'], error: string) => logVideoCallError(trackEvent, eventType, error),
    collectDeviceInformation: () => collectWebDeviceInformation(trackEvent),
  };
}; 